import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, NgZone } from '@angular/core';
import { Router } from '@angular/router';
// import { SwUpdate } from '@angular/service-worker';
import { MenuController, Platform, ToastController, AlertController, ModalController, NavParams } from '@ionic/angular';
import { Keyboard } from '@capacitor/keyboard';
import { StatusBar } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
// import { Device } from '@capacitor/device';
import { Storage } from '@ionic/storage';
import { PushNotifications } from '@capacitor/push-notifications';
import { UserData } from './providers/user-data';
import { FcmService } from './providers/fcm';
import { UserService } from "./providers/user";
import { DeviceMotionService } from "./providers/device-motion";
import { AppConfigService } from "./providers/app-config";
import { SeedService } from "./providers/seed";
import { ReportService } from "./providers/report";
import { CheckNetworkService } from "./providers/check-network";
import { Preferences } from '@capacitor/preferences';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { KeepAwake } from '@capacitor-community/keep-awake';
import { PaymentService } from './providers/payment';
// import { SafeArea } from '@capacitor-community/safe-area';
import { ScreenOrientation } from '@capacitor/screen-orientation';
declare var window;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  appPages = [
    {
      title: 'FAQs',
      url: '/faqs',
      icon: 'information-circle'
    },
    {
      title: 'T&C',
      url: '/terms',
      icon: 'newspaper'
    },
    // {
    //   title: 'Help',
    //   url: '/help',
    //   icon: 'help',
    // },
    {
      title: 'Contact Us',
      url: '/about',
      icon: 'chatbubble-ellipses'
    }
  ];
  loggedIn = false;
  dark = false;
  public showSplash = true;
  private exitReady = false;
  // public platformResume:any;
  // public platformPause:any;
  public internet = false;
  private res: any;
  public helpClicked;
  public imgsLen = 0;
  deferredPrompt: any;
  constructor(
    private menu: MenuController,
    private platform: Platform,
    private router: Router,
    private zone: NgZone,
    private fcm: FcmService,
    private storage: Storage,
    private userData: UserData,
    public stepCounter: DeviceMotionService,
    public user: UserService,
    private toastCtrl: ToastController,
    private toaster: ToastController,
    public seed: SeedService,
    private appConfig: AppConfigService,
    public reports: ReportService,
    public payment: PaymentService,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public networkProvider: CheckNetworkService
  ) {
    this.initializeApp();
    // this.menu.enable(false);
  }

  async ngOnInit() {

    console.log("implemented");
    try {
      this.platform.ready().then(async () => {
        // const keepAwake = async () => {
        await KeepAwake.keepAwake();
        // };
        // const isSupported = async () => {
        const result = await KeepAwake.isSupported();
        console.log(result);
        // };
        // let info = await Device.getInfo();
        // // "model": "moto g62 5G",
        // // "name": "moto g62 5G",
        // // "platform": "android",
        // // "version": "13",
        // // "manufacturer": "motorola",
        // // "uuid": "4cd1642e519a3598",
        // if (info.platform == 'android' && parseInt(info.osVersion) <= 11){
        //   this.platformPause = this.platform.pause.subscribe(async () => {
        //     this.stepCounter.startStepCount();
        //   });
        // ///your fix for lower versions of android
        // }
        ScreenOrientation.unlock().catch(() => { });
        this.checkNavigation();
        // window.screen.orientation.lock('portrait-primary').then(r => {
        //   console.log("orientitaion changed and locked app.component", r);
        //   this.checkNavigation();
        // }).catch(e => {
        //   console.error("acso", e, e.stack, e.message);
        //   this.checkNavigation();
        // });
        this.stepCounter.startStepCount();
        // window.screen.orientation.lock('landscape');
      });

    } catch (error) {
      console.log("orientitaion error", error);
    }

    try {
      this.platform.ready().then(async () => {
        this.checkNativeUser();
        window.addEventListener('offline', () => {//Do task when no internet connection});
          this.user.isNetwork = false;
          alert("Please connect to internet for better working")
          console.log("im inside offline addEventListener", this.user.isNetwork);
        });

        window.addEventListener('online', () => {//Do task when no internet connection});
          this.user.isNetwork = true;
          console.log("im inside online addEventListener", this.user.isNetwork);
        });
        await StatusBar.setBackgroundColor({ color: '#000000' });
        // SafeArea.enable({ config :{
        //   customColorsForSystemBars: true,
        //   statusBarColor: '#00000000', // transparent
        //   statusBarContent: 'light',
        //   navigationBarColor: '#00000000', // transparent
        //   navigationBarContent: 'light',
        // }});
      });
      // await this.platform.backButton.subscribe(() => this.backButtonHandler());
    } catch (error) {
      console.log("online error", error);
    }
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
      // Update UI notify the user they can install the PWA
      // this.showInstallPromotion();
      console.log('beforeinstallprompt event fired');
    });

  }

  async initializeApp() {
    this.platform.ready().then(async () => {
      App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        this.zone.run(() => {
          const domain = 'livechek.com';

          const pathArray = event.url.split(domain);
          // The pathArray is now like ['https://devdactic.com', '/details/42']

          // Get the last element with pop()
          const appPath = pathArray.pop();
          if (appPath) {
            this.router.navigateByUrl(appPath);
          }
        });
      });
      await this.user.permissions();
      this.fcm.initPush();
      // document.querySelector('body').setAttribute('data-theme', 'light');
      // document.querySelector('body').classList.toggle('dark', false);
      try {
        // document.querySelector('body').classList.remove('camera-active');
        // await StatusBar.hide();
        // await SplashScreen.show();
      } catch (error) {

      }

      // this.router.navigate(['/auth']);
      // }
    });
  }
  loadAfterLoadingPageFlag = false;
  async reload() {
    await SplashScreen.show();
    window.location.reload(true);
  }
  openHome() {
    if (this.router.url === '/home') {
      this.userData.refreshHome();
    } else {
      this.router.navigateByUrl('/home');
    }
  }

  async checkNativeUser() {
    //  let data: any = await Preferences.get({ key: 'user' });
    // if (data != null && data != undefined && data.value && data.value != null && data.value != undefined) {
    //   let newData = await JSON.parse(data.value);
    let data = localStorage.getItem('user');
    if (data != null && data != undefined) {
      let newData = await JSON.parse(data);
      if (newData && newData.mobile && newData.status && newData.status == 'active') {
        this.user.mobile = newData.mobile;
        this.user.name = newData.name;
        this.user.appState = newData.appState;
        this.user.appKey = newData.appKey;
        this.user.allApps = newData.allApps;
        this.user.details = newData.details;
        this.user.language = newData.language;
        this.user.companyId = newData.companyId;
        this.user.allCompany = newData.allCompany;
        this.user.appUserId = newData.appUserId;
        this.user.appType = newData.appType;
        //checking start time if request is there in upload queue
        // let time = await Preferences.get({ key: 'startTime' });
        let time = localStorage.getItem('startTime');
        console.log("strt time data", time);
        // if (time != null && time != undefined && time.value && time.value != null && time.value != undefined) {
        // let newTime = await JSON.parse(time.value);
        if (time != null && time != undefined) {
          let newTime = await JSON.parse(time);
          if (newTime && newTime.startTime) {
            var startTime = newTime.startTime;
            startTime = Date.parse(new Date(startTime).toISOString());
            var currentTime = new Date().getTime();
            //removing the request if time is greater then 3hr
            let t3 = Math.ceil(parseFloat(((currentTime - startTime) / (1000 * 60)).toFixed(2)));
            console.log("strt time data", currentTime, startTime, t3);
            if (t3 >= 180) {

              // await Preferences.remove({ key: "startTime" });
              // await Preferences.remove({ key: "inProcess" });
              localStorage.removeItem("inProcess");
              localStorage.removeItem("startTime");
            }
          }
        }
        // let oData = await Preferences.get({ key: 'offline' });
        //   if (oData != null && oData != undefined && oData.value && oData.value != null && oData.value != undefined) {
        //     let newoData = await JSON.parse(oData.value);
        //     this.reports.offline = data;
        let oData = localStorage.getItem('offline');
        if (oData != null && oData != undefined) {
          let newoData = await JSON.parse(oData);
          this.reports.offline = newData;
        }
        //  let inData = await Preferences.get({ key: 'inProcess' });
        //         if (inData != null && inData != undefined && inData.value && inData.value != null && inData.value != undefined) {
        //           let newinData = await JSON.parse(inData.value);
        let inData = localStorage.getItem('inProcess');
        if (inData != null && inData != undefined) {
          let newinData = await JSON.parse(inData);
          if (newinData && newinData.reportId) {
            this.reports.process = newinData.process,
              this.reports.stencilsData = newinData.stencilsData,
              this.reports.claimForm = newinData.claimForm,
              this.reports.appConfig = newinData.appConfig,
              this.reports.walkDirection = newinData.walkDirection,
              this.user.appState = newinData.appState,
              this.reports.imageTypeTaken = newinData.imageTypeTaken,
              this.reports.fileNames = newinData.fileNames,
              this.reports.videoObject = newinData.videoObject,
              this.reports.audioObject = newinData.audioObject,
              this.reports.signObject = newinData.signObject,
              this.reports.imageTypes = newinData.imageTypes,
              this.reports.reportImg = newinData.reportImg,
              this.reports.hiddenImages = newinData.hiddenImages,
              this.reports.workshops = newinData.workshops,
              this.reports.fileUploadMonitor = newinData.fileUploadMonitor,
              this.reports.id = newinData.reportId,
              this.payment.txnSt = newinData.txnSt,
              this.payment.txnId = newinData.txnId,
              this.payment.nextpage = newinData.nextpage,
              this.payment.regNumber = newinData.regNumber,
              this.reports.app = newinData.app,
              this.reports.changeProcess = newinData.changeProcess,
              this.reports.processChanged = newinData.processChanged,
              this.reports.praReport = newinData.praReport,
              this.reports.companyId = newinData.companyId,
              this.reports.survey = newinData.survey,
              this.reports.surveyType = newinData.surveyType,
              this.reports.localFiles = newinData.localFiles,
              this.reports.hiddenImageCount = newinData.hiddenImageCount,
              this.reports.putMonitor = newinData.putMonitor;
            this.reports.picNoCSP = newinData.picNoCSP > 2 ? newinData.picNoCSP - 1 : 0;
            if (this.user.appState == "FinalPage" || "CameraStencilsPage") { this.reports.onResume = true; }
            try {
              // if (newinData.fileUploadMonitor.findIndex((o) => o.filename.includes("hidden_audio")) < 0 ){
              //   this.user.appState = "CameraStencilsPage";
              // }
              this.goToPage(this.appConfig.possibleStates[this.user.appState]);
            } catch (e) {
              this.goToPage(this.appConfig.possibleStates[this.user.appState]);
            }
          } else {

            // await Preferences.remove({ key: "startTime" });
            // await Preferences.remove({ key: "inProcess" });
            localStorage.removeItem("inProcess");
            localStorage.removeItem("startTime");
            this.goToPage(this.appConfig.possibleStates['HomePage']);
          }
        } else {
          this.goToPage(this.appConfig.possibleStates['HomePage']);
        }
      } else {
        await SplashScreen.hide();
      }
    } else {
      await SplashScreen.hide();
    }
  }

  checkNavigation() {
    this.user.screenHeight = window.screen.height;
    this.user.screenWidth = window.screen.width;
    let inwidth = window.innerWidth;
    let inner = window.innerHeight;
    console.log(this.user.screenWidth, this.user.screenHeight, inwidth, inner);
    if (this.user.screenWidth > this.user.screenHeight && this.user.screenWidth - inwidth > 40) this.user.onScreenNavigation = true;
    if (this.user.screenHeight - inner > 40) this.user.onScreenNavigation = true;
    // this.enableFullScreen();
  }

  async clearCache() {
    //     let cache: any = await Preferences.get({ key: 'cachedkeys' });
    // if (cache != null && cache != undefined && cache.value && cache.value != null && cache.value != undefined) {
    //   let data = JSON.parse(cache.value);
    let cache = localStorage.getItem('cachedkeys');
    if (cache != null && cache != undefined) {
      let data = JSON.parse(cache);
      if (data && data.key) {
        console.log("cached data", data.key);
        let cached = data.key;
        for (var i = 0; i < cached.length; i++) {
          // await Preferences.remove({ key: cached[i] });
          localStorage.removeItem(cached[i]);
        }
        localStorage.removeItem("cachedkeys");
      } else console.log("no cache found");
    }
  }

  goToPage(page, helpClicked?) {
    //this.apps[4] ----> update with app index of builded app
    // this.http.get(apiBaseUrl + 'update_app?app=' + this.apps[2])
    //   .map(res => res.json())
    //   .subscribe(res => {
    //     this.user.appDetails = res.data;
    //     console.log('update_app get res', res.data);
    //     this.user.appVersion = this.version;
    //     this.versionCompare(this.version, res.data.version);

    //     setTimeout(() => {
    //       if (res && res.data && this.updateApp) {
    //         console.log('inside vertsion more true');
    //         const actionSheet = this.actionSheetCtrl.create({
    //           title: 'New Update Available',
    //           buttons: [
    //             {
    //               text: 'Update Now',
    //               role: 'playstore',
    //               icon: !this.platform.is('ios') ? 'md-appstore' : 'ios-appstore-outline',
    //               handler: () => {
    //                 console.log('update Now clicked clicked');
    //                 this.market.open(res.data.name).then(() => {
    //                   console.log("this.market.open ----->");
    //                 });
    //               }
    //             },
    //             {
    //               text: 'Later',
    //               role: 'cancel',
    //               icon: 'md-close',
    //               handler: () => {
    //                 console.log('Cancel clicked');
    //               }
    //             }
    //           ]
    //         });
    //         actionSheet.present();
    //       }
    //     }, 2000);
    //   }, (err) => {
    //   });
    this.user.openFullscreen('landscape-primary');
    this.router.navigateByUrl(page, { skipLocationChange: true, replaceUrl: true }).then(async () => {
      await SplashScreen.hide();
    })
  }

  async appCloseConfirm() {
    let alert = await this.alertCtrl.create({
      header: "Do you want to close the app?",
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          },
        },
        {
          text: "Yes",
          handler: () => {
            console.log("Impact confirmed");
            App.exitApp();
          },
        },
      ],
    });
    await alert.present();
  }

  versionCompare(v1, v2) {

    var versionOld = v1.split('.');
    var versionNew = v2.split('.');
    console.log("versionOld --->", versionOld, "versionNew --->", versionNew);

    if (parseInt(versionOld[0]) <= parseInt(versionNew[0])) {
      if (parseInt(versionOld[1]) <= parseInt(versionNew[1])) {
        if (parseInt(versionOld[2]) < parseInt(versionNew[2])) {
          return true;
        } else
          return false;
      } else
        return false;
    } else
      return false;
  }

  async backButtonHandler() {
    if (this.exitReady) {
      this.appCloseConfirm();
    } else {
      let toast = await this.toaster.create({
        message: "Press Again to Confirm Exit",
        duration: 3000,
      });
      await toast.present();
      this.exitReady = true;
      setTimeout(() => {
        this.exitReady = false;
      }, 3000);
    }
  }
  async loadAfterLoadingPage() {
    if (this.loadAfterLoadingPageFlag) return;
    this.loadAfterLoadingPageFlag = true;

    Keyboard.addListener('keyboardDidShow', (info) => {
      console.log('keyboard did show with height', info.keyboardHeight);
      this.user.isKeyboardHide = false;
      StatusBar.setBackgroundColor({ color: '#ffffff' });
      this.user.onScreenNavigation ? this.user.keyboardHeight = info.keyboardHeight + 60 : this.user.keyboardHeight = info.keyboardHeight + 15;
    });
    Keyboard.addListener('keyboardDidHide', () => {
      console.log('keyboard did hide');
      this.user.isKeyboardHide = true;
      StatusBar.setBackgroundColor({ color: '#000000' });
    });
  }

  async logout() {
    //this.user = null;
    let alert = await this.alertCtrl.create({
      header: "Are you sure wants to Logout?",
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          },
        },
        {
          text: "Yes",
          handler: async () => {
            console.log("Impact confirmed");
            await this.user.showLoader();

            // await Preferences.remove({ key: 'inProcess' });
            // await Preferences.remove({ key: 'startTime' });
            // await Preferences.remove({ key: 'cachedkeys' });
            localStorage.removeItem('user');
            localStorage.removeItem('inProcess');
            localStorage.removeItem('startTime');
            this.user.mobile = null;
            this.reports.clearData();
            this.router.navigateByUrl('/auth', { skipLocationChange: true, replaceUrl: true });
            await this.user.hideLoader();
          },
        },
      ]
    });
    await alert.present();
  }

  async createShortcut() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      console.log(`User response to the install prompt: ${outcome}`);
      this.deferredPrompt = null;
    } else {
      // Show instruction if prompt is not available (e.g. already installed or not supported)
      let alert = await this.alertCtrl.create({
        header: 'Install App',
        message: 'To install this app, tap the "Share" icon in your browser menu and select "Add to Home Screen".',
        buttons: ['OK']
      });
      await alert.present();
    }
  }

  public _peer;
  public myCallId;

  async loadUser() {
    //     let data: any = await Preferences.get({ key: 'user' });
    // if (data != null && data != undefined && data.value && data.value != null && data.value != undefined) {
    //   let newData = JSON.parse(data.value);
    let data = localStorage.getItem('user');
    if (data != null && data != undefined) {
      let newData = JSON.parse(data);
      if (newData && newData.mobile) {
        this.user.mobile = newData.mobile;
        this.user.name = newData.name;
        this.user.allApps = newData.allApps;
        this.user.appState = newData.appState;
        this.user.appKey = newData.appKey;
        this.user.otp = newData.otp;
        this.user.appType = newData.appType;
        this.user.appUserId = newData.appUserId;
        this.user.companyId = newData.companyId;
      }
    }
  }
  async confirm(data) {
    let inputA = [];
    for (var j = 0; j < data.length; j++) {
      inputA.push({
        type: "radio",
        label: data[j].title.toUpperCase(),
        value: data[j].others.value,
        checked: data[j].others.value == this.user.language ? true : false,
      });
    }
    const alert = await this.alertCtrl.create({
      header: "Select Language",
      inputs: inputA,
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: (data1) => {
            this.user.language = data1;
          },
        },
        {
          text: "Ok",
          handler: (data2) => {
            this.user.language = data2;
          },
        },
      ]
    });
    await alert.present();
  }
  selectLanguage() {
    this.seed.getSeedbyUrl("seeds?class=languages&all=true", []).then((data) => {
      this.appConfig.languages = [];
      if (data && data[0]._id) {
        this.appConfig.languages.push(data);
        this.confirm(data);
      } else {
        this.appConfig.languages.push({
          others: { value: "english", locale: "en-US", rate: "0.9" },
        });
        this.user.language = "english";
      }
    });
  }
  public setup() {
    console.log("i am inside Setup appComponent");
    if (this.user.mobile) {
      //this.connect(this.user.mobile);
      //this.reconnetor();
    } else {
      setTimeout(() => {
        this.loadUser();
        this.setup();
      }, 1500);
    }
  }

  // reconnetor() {
  //   setTimeout(() => {
  //     if (this._peer && this._peer.disconnected && this._peer.disconnected == true) {
  //       console.log("o'connor dic true", this._peer);
  //       setTimeout(() => { this.setup(); }, 1000);
  //     }
  //   }, 2000);
  // }

  // connect(mobile) {
  //   //
  //   try {
  //     if (this._peer && this._peer.socket && this._peer.socket.id) {
  //       console.log("Already exist", this._peer);
  //       //this._peer.reconnect();
  //       this._peer.socket.close();
  //       this._peer = null;
  //       this.internet = false;
  //       // //this._peer.socket.close();
  //       // // this._peer.destroy(this._peer.socket.id);
  //       setTimeout(() => {
  //         this.internet = false;
  //         this.checkInternet();
  //       }, 1000);
  //     } else {
  //       this._peer = new Peer(mobile, {
  //         host: "peer.dev.livechek.com",
  //         port: 443,
  //         secure: true,
  //         path: "/peerjs",
  //         debug: 3,
  //         config: {
  //           iceServers: [
  //             { url: "stun:stun01.sipphone.com" },
  //             { url: "stun:stun.ekiga.net" },
  //             { url: "stun:stun.fwdnet.net" },
  //             { url: "stun:stun.ideasip.com" },
  //             { url: "stun:stun.iptel.org" },
  //             { url: "stun:stun.rixtelecom.se" },
  //             { url: "stun:stun.schlund.de" },
  //             { url: "stun:stun.l.google.com:19302" },
  //             { url: "stun:stun1.l.google.com:19302" },
  //             { url: "stun:stun2.l.google.com:19302" },
  //             { url: "stun:stun3.l.google.com:19302" },
  //             { url: "stun:stun4.l.google.com:19302" },
  //             { url: "stun:stunserver.org" },
  //             { url: "stun:stun.softjoys.com" },
  //             { url: "stun:stun.voiparound.com" },
  //             { url: "stun:stun.voipbuster.com" },
  //             { url: "stun:stun.voipstunt.com" },
  //             { url: "stun:stun.voxgratia.org" },
  //             { url: "stun:stun.xten.com" },
  //             {
  //               url: "turn:numb.viagenie.ca",
  //               credential: "muazkh",
  //               username: "webrtc@live.com",
  //             },
  //             {
  //               url: "turn:192.158.29.39:3478?transport=udp",
  //               credential: "JZEOEt2V3Qb0y27GRntt2u2PAYA=",
  //               username: "28224511:1379330808",
  //             },
  //             {
  //               url: "turn:192.158.29.39:3478?transport=tcp",
  //               credential: "JZEOEt2V3Qb0y27GRntt2u2PAYA=",
  //               username: "28224511:1379330808",
  //             },
  //           ],
  //         },
  //       });

  //       setTimeout(() => {
  //         console.log("===>>>>> the peer", this._peer, this._peer.disconnected);
  //         this.myCallId = this._peer.id;
  //         if (this._peer.disconnected) {
  //           this._peer.destroy();
  //           this._peer.socket.close();
  //           this._peer = null;
  //           setTimeout(() => {
  //             this.internet = false;
  //             this.checkInternet();
  //           }, 2000);
  //         } else {
  //           this._peer.on("call", (call) => {
  //             this.callConfirm(call);
  //           });
  //           this._peer.on("error", (e) => {
  //             console.log(e, ":;on error called");
  //             //this._peer.reconnect();
  //             setTimeout(() => {
  //               this.internet = false;
  //               this.checkInternet();
  //             }, 1000);
  //           });
  //         }
  //       }, 5000);
  //     }
  //   } catch (e) {
  //     console.log("Fucking error; trying again", e);
  //     this.internet = false;
  //     this.setup();
  //   }
  // }

  // public ringTone = null;
  // callConfirm(call) {
  //   this.ringtones.getRingtone().then((ringtones) => {
  //     console.log("ringtones", ringtones);
  //     this.ringTone = ringtones[0].Url;
  //     this.ringtones.playRingtone(this.ringTone).catch((e) => {
  //       console.log("ringtones play error", e);
  //     });
  //   }).catch((e) => {
  //     console.log("ringtones not avil", e);
  //   });

  //   this.alertCtrl.create({
  //     title: call.peer + " calling",
  //     // message: 'Does '+this.stencils[this.picNo].type+' side got impacted?',
  //     buttons: [
  //       {
  //         text: "Reject",
  //         role: "cancel",
  //         handler: () => {
  //           console.log("Cancel clicked");
  //           this.internet = false;
  //           this.ringtones.stopRingtone(this.ringTone);
  //         },
  //       },
  //       {
  //         text: "Answer",
  //         handler: () => {
  //           console.log("Impact confirmed", call);
  //           this.ringtones.stopRingtone(this.ringTone);
  //           this.presentProfileModal(call);
  //         },
  //       },
  //     ],
  //     enableBackdropDismiss: false,
  //   }).present();
  // }

  // presentProfileModal(call) {
  //   let profileModal = this.modalCtrl.create(VideoCall, {
  //     call: call,
  //     _peer: this._peer,
  //   });
  //   profileModal.onDidDismiss((data) => {
  //     console.log(data);
  //   });
  //   profileModal.present();
  // }
}

// @Component({
//   template:
//     "<div class='video-container'  (click)=\"lolz=!lolz\" >" +
//     '<video [ngClass]=" (lolz === true)?\'peerVideo\':\'userVideo\'" muted="true" id="my-video" autoplay></video>' +
//     "<video [ngClass]=\" (lolz === true)?'userVideo':'peerVideo'\"  id=\"other-video\" autoplay></video>" +
//     "</div>" +
//     '<ion-fab bottom right *ngIf="volume"> <button ion-fab (click)="mute()"><ion-icon name="md-volume-up" color="white" ></ion-icon></button></ion-fab>' +
//     '<ion-fab bottom right *ngIf="!volume"> <button ion-fab (click)="mute()"><ion-icon name="md-volume-off" color="white" ></ion-icon></button></ion-fab>' +
//     //'<ion-fab bottom left> <button ion-fab (click)="flashLight()"><ion-icon name="flash" [color]="flash?\'white\':\'danger\'" ></ion-icon></button></ion-fab>'+
//     '<ion-fab bottom center><button color="danger" ion-fab (click)="closeModal()"><ion-icon name="md-call" ></ion-icon></button></ion-fab>',

//   styles: [
//     ".video-container { position:absolute; height:100%;min-height:100%; background:white no-repeat; background-size:cover;} .userVideo {height:100%; } .peerVideo { position: fixed; width:100px;border:2px solid black;float: right;bottom:60px;right:5px; background: url(./assets/img/Livechek_text.png) no-repeat; background-size: cover; }",
//   ],
// })
// export class VideoCall {
//   public call: any;
//   public lolz = false;
//   public volume = true;
//   public flash = false;
//   public _setup: any;
//   constructor(
//     public viewCtrl: ModalController,
//     public navParams: NavParams,
//     // private flashlight: Flashlight,
//     private elRef: ElementRef,
//     // public events: Events
//   ) {
//     this.call = navParams.get("call");
//     this._peer = navParams.get("_peer");
//   }
//   public _peer;
//   public myCallId;

//   myVideo: HTMLMediaElement;
//   otherVideo: HTMLMediaElement;
//   public _localStream;
//   public startCall = false;
//   ionViewDidLoad() {
//     this.init();
//     setTimeout(() => { this.call.answer(this._localStream); }, 2000);
//     this._step3(this.call);
//   }
//   mute() {
//     console.log("volume", this.volume);
//     this.volume ? (this.volume = false) : (this.volume = true);
//     this.myVideo = this.elRef.nativeElement.querySelector("#my-video");
//     this.myVideo.muted = this.volume ? true : false;
//   }
//   // flashLight() {
//   //   this.flash ? (this.flash = false) : (this.flash = true);
//   //   if (this.flashlight.available()) {
//   //     this.flashlight.toggle().catch((e) => {
//   //       console.log("error in toggle", e);
//   //     });
//   //     console.log(this.flashlight);
//   //   }
//   // }
//   init() {
//     this.myVideo = this.elRef.nativeElement.querySelector("#my-video");
//     console.log(this.myVideo);
//     this.otherVideo = this.elRef.nativeElement.querySelector("#other-video");
//     this._step1();
//   }

//   outcall(otherUserId: string) {
//     this.init();
//     // Initiate a call!
//     var call = this._peer.call(otherUserId, this._localStream);

//     this._step3(call);
//   }

//   public _existingCall;
//   // endCall() {
//   //   this._existingCall.close();
//   //   this._peer.destroy();
//   //   this.viewCtrl.dismiss();
//   //  endCall //this.events.publish('video:ended');
//   // }

//   public front = true;
//   private _step1() {
//     var navigaotr = <any>navigator;
//     this.front = !this.front;
//     var constraints = null;
//     // { frameRate: { ideal: 10, max: 15 } }
//     if (this.front) {
//       constraints = {
//         audio: true,
//         video: {
//           facingMode: "user",
//           frameRate: { ideal: 8, max: 11 },
//           width: { ideal: 400, max: 800 },
//           height: { ideal: 600, max: 1024 },
//         },
//       };
//     }
//     else {
//       constraints = { audio: true,
//         video: { facingMode: { exact: "environment" } },
//       };
//     }

//     navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
//         /* use the stream */
//       this.myVideo.srcObject = stream;
//       this._localStream = stream;
//     }).catch(function (err) {
//       /* handle the error */
//       console.log("error while getting native media", err);
//       navigaotr.getUserMedia = navigaotr.getUserMedia || navigaotr.webkitGetUserMedia || navigaotr.mozGetUserMedia || navigaotr.msGetUserMedia;
//       navigaotr.getUserMedia({ audio: true, video: true },function (res) {
//         this.myVideo.srcObject = res;
//         this._localStream = res;
//       }, function (err) {
//         console.log("error in getting media ", err);
//       });
//     });
//   }

//   private _step3(call) {
//     // Hang up on an existing call if present

//     console.log(call, "in call connected");
//     if (this._existingCall) {
//       this._existingCall.close();
//       //this._peer.destroy();
//       // this.viewCtrl.dismiss();
//       // this.events.publish('video:ended');
//     }

//     // Wait for stream on the call, then set peer video display
//     call.on("stream", (stream) => {
//       const mediaSource = new MediaSource();
//       this.otherVideo.srcObject = stream;
//     });

//     // UI stuff
//     this._existingCall = call;
//     console.log("hi", this._existingCall);
//     // $('#their-id').text(call.peer);
//     call.on("close", () => {
//       this._existingCall.close();
//       this._peer.destroy();
//       this.viewCtrl.dismiss();
//       // this.events.publish("video:ended");
//       //this._setup;
//       //window.location.reload(true);
//     });
//     // $('#_step1, #_step2').hide();
//     // $('#_step3').show();
//   }

//   dismiss() {
//     this._existingCall.close();
//     this._peer.destroy();
//     this.viewCtrl.dismiss();
//     // this.events.publish("video:ended");
//     //this._setup;
//     //window.location.reload(true);
//   }

//   closeModal() {
//     this._existingCall.close();
//     this._peer.destroy();
//     this.viewCtrl.dismiss();
//     // this.events.publish("video:ended");
//     //this._setup;
//     //window.location.reload(true);
//   }
// }